define('fusion/log-flags',[],function () {
    return {
        error: 1,
        warning: 2,
        analytic: 4,
        debug: 8,
        trace: 16
    };
});
